"use client";

import { Loader } from "@googlemaps/js-api-loader"
import { useEffect } from "react"

export default function Map({ additionalOptions }) {
	useEffect(() => {
		const loader = new Loader({
			apiKey: "AIzaSyBnea--5mCZY8SjJKiC3KvsoNVFyzaVR6U",
			version: "weekly",
			...additionalOptions,
		});

		loader.importLibrary('maps')
			.then(async ({ Map }) => {
				const map = new Map(document.getElementById("map"), {
					mapId: "f73a0521d7153b64", // use separate IDs for light and dark maps!
					center: { lat: 60.455, lng: 11.100 },
					zoom: 12.1,
					mapTypeControl: false,
					fullscreenControl: false,
					streetViewControl: false,
					// styles: // TODO: Set in Google cloud dashboard now
				});
				
				if (!map.getMapCapabilities().isAdvancedMarkersAvailable)
					return
				
				const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
				
				// const tag = document.createElement("div");
				// tag.className = styles.location;
				// tag.textContent = "Lium Gård";

				new AdvancedMarkerElement({
					map,
					position: { lat: 60.467959, lng: 11.1717596 },
					// content: tag
				});
		  	});
	}, [])

	return (<div id="map" style={{ width:"100%", height:"100%" }}/>)
}